import {Page} from 'utils/page-utils';
import CMSUtils from 'utils/cms';
import {PRISMIC_CUSTOM_TYPE} from 'utils/prismic-types';
import {initialState as searchRequestInitialState} from 'store/search-request/search-request-reducer';

const getInitialState = async ({state, cookies, params: {slug}}) => ({
    ...state,
    searchRequest: {
        ...searchRequestInitialState,
        pageType: Page.LEGAL,
    },
    page: await CMSUtils.getPageData({
        cookies,
        slug,
        customType: PRISMIC_CUSTOM_TYPE.LEGAL,
    }),
});

export default getInitialState;
